import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Frank Coel – Lawyer in Mechelen"}
                    description={"Lawyer in administrative law, constitutional law, civil law and criminal law. Mergers, acquisitions and liquidations and disputes between partners."}
                    url={"https://www.coeladvocaten.be/en/frank-coel"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/frank-coel", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/frank-coel", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/frank-coel", language:"en" }
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl/frank-coel"
                    switchUrlFR="/fr/frank-coel"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-team"></div>
                        <div className="slider">
                            <h1>Our team</h1>
                            <h2>Frank Coel</h2>
                            <p></p>
                            <a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <div className="image">
                                                <img className="img-fluid grayscale team-image-opacity" src="/static/images/ons-team-frank.jpg" width="100%" height="auto" /> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Frank Coel specializes in defending the rights of individuals and companies, in particular against governments. As a lawyer, he defends in administrative law, constitutional law, civil law and criminal law. In addition, he is an expert in mergers, acquisitions and liquidations and a mediator in disputes between partners.</p>
                                            <p></p>
                                            <p><b>Specialties</b></p>
                                            <p>
                                                <ul>
                                                    <li><b>Administrative law:</b> defense of individuals and companies against decisions of government agencies, at any level. From a simplified review procedure to an appeal to the Council of State.</li>
                                                    <li><b>Civil service law:</b> appointment procedures, dismissals and resignations of statutory and contractual personnel.</li>
                                                    <li><b>Criminal law:</b> defense of defendants and victims before the police court and the court of first instance to the Court of Cassation.</li>
                                                    <li><b>Business law:</b> mergers, acquisitions, reorganizations, liquidations, disputes between partners.</li>
                                                    <li><b>Civil law:</b> agricultural lease, long lease, easement, (commercial) lease agreements, and appeal against expropriations.</li>
                                                </ul>
                                            </p>
                                            <p><b>Studies and training</b></p>
                                            <p>Licentiate in Law – Vrije Universiteit Brussel – 1990</p>
                                            <p>Legal internship at Feremans, Vets & Verreydt in Mechelen</p>
                                            <p>Certificate of training Cassation in criminal cases – 2016</p>
                                            <p><b>Activities</b></p>
                                            <p>
                                                <ul>
                                                    <li>Member of the Mechelen Bar, then the Province of Antwerp Bar, since 1990</li>
                                                    <li>Member of the Council and treasurer at the Mechelen Bar Association until 2019</li>
                                                    <li>Member of various commissions at the Order of Flemish Bars</li>
                                                    <li>Member of the Disciplinary Council on Appeal since 2019 </li>
                                                    <li>Provincial Councilor at the Province of Antwerp from 2000 to 2006</li>
                                                </ul>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                        </div>
                    </div>
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
